import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/videos',
    name: 'videos',
    component: () => import(/* webpackChunkName: "videos" */ '../views/VideosView.vue')
  },
  {
    path: '/videos/:slug',
    name: 'video-detail',
    component: () => import(/* webpackChunkName: "video-detail" */ '../views/VideoDetailView.vue'),
    props: true
  },
  {
    path: '/merch',
    name: 'merch',
    component: () => import(/* webpackChunkName: "merch" */ '../views/MerchView.vue')
  },
  {
    path: '/stream',
    name: 'stream',
    component: () => import(/* webpackChunkName: "stream" */ '../views/StreamView.vue')
  },
  {
    path: '/affiliates',
    name: 'affiliates',
    component: () => import(/* webpackChunkName: "affiliates" */ '../views/AffiliatesView.vue')
  },
  {
    path: '/campaigns',
    name: 'campaigns',
    component: () => import(/* webpackChunkName: "campaigns" */ '../views/CampaignsView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
